// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1VR2l","inner":"Form_inner__10O2M","range":"Form_range__138dh","name":"Form_name__1l5AV","actions":"Form_actions__15b_U"};